import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const StepWrapperStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 3rem 2rem 4rem;
  margin-bottom: 6rem;
`;

export const TitleAccentedWordStyled = styled.b`
  color: ${colors.green[600]};
  font-style: italic;
`;

export const StepBodyStyled = styled.div`
  border-top: 1px solid ${colors.neutral[300]};
  display: flex;
  padding: 2.5rem 0 0;
`;

export const LinkStyled = styled.p`
  color: ${colors.neutral[900]};
  background-color: ${colors.neutral[100]};
  border-radius: 10px;
  padding: 1rem 3rem;
  font-size: 1.6rem;
  line-height: 2.4rem;
  flex-basis: 70%;
  margin: 0;
  word-break: break-word;
`;

export const ContentWrapperStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 3rem;
`;

export const StepSubtitleStyled = styled.p`
  max-width: 65rem;
  margin: 0 auto;
`;
